import { upsertLineItems } from './upsertLineItems.utils';
async function dynamicLoadCartQueries(httpClient) {
  return (await import('../premium-cart.api-client')).PremiumCartInternalApiClient.queries({
    httpClient
  });
}
async function dynamicLoadCartApiClient() {
  return (await import('../premium-cart.api-client')).PremiumCartInternalApiClient;
}
export const CartApiClientUtils = {
  upsertLineItems,
  dynamicLoadCartQueries,
  dynamicLoadCartApiClient
};
//# sourceMappingURL=cart-api-client.utils.js.map